import React, { useRef, useEffect } from "react";
import { Bold, Italic, List, ListOrdered, Heading2, Link2, Undo, Quote } from "lucide-react";

const cmd = (c, v = null) => document.execCommand(c, false, v);

const Btn = ({ icon: Icon, action, title }) => (
  <button type="button" title={title} onMouseDown={(e) => { e.preventDefault(); action(); }}
    className="flex h-8 w-8 items-center justify-center rounded-md text-navy/70 hover:bg-navy/10 hover:text-navy transition-colors">
    <Icon className="h-4 w-4" />
  </button>
);

export const RichTextEditor = ({ value, onChange, testid = "rich-editor" }) => {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) {
      ref.current.innerHTML = value || "";
    }
    // eslint-disable-next-line
  }, []);

  const emit = () => onChange(ref.current?.innerHTML || "");
  const link = () => { const url = window.prompt("URL du lien (https://...)"); if (url) { cmd("createLink", url); emit(); } };

  return (
    <div className="rounded-lg border border-slate-200 overflow-hidden bg-white">
      <div className="flex flex-wrap items-center gap-0.5 border-b border-slate-200 bg-ivory px-2 py-1.5">
        <Btn icon={Heading2} title="Titre" action={() => { cmd("formatBlock", "<h2>"); emit(); }} />
        <Btn icon={Bold} title="Gras" action={() => { cmd("bold"); emit(); }} />
        <Btn icon={Italic} title="Italique" action={() => { cmd("italic"); emit(); }} />
        <Btn icon={List} title="Liste à puces" action={() => { cmd("insertUnorderedList"); emit(); }} />
        <Btn icon={ListOrdered} title="Liste numérotée" action={() => { cmd("insertOrderedList"); emit(); }} />
        <Btn icon={Quote} title="Citation" action={() => { cmd("formatBlock", "<blockquote>"); emit(); }} />
        <Btn icon={Link2} title="Lien" action={link} />
        <Btn icon={Undo} title="Annuler" action={() => { cmd("undo"); emit(); }} />
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        onInput={emit}
        onBlur={emit}
        data-testid={testid}
        className="prose max-w-none min-h-[240px] px-4 py-3 text-slate-700 leading-relaxed focus:outline-none [&_h2]:font-serif [&_h2]:text-xl [&_h2]:font-semibold [&_h2]:text-navy [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:list-decimal [&_ol]:pl-6 [&_blockquote]:border-l-4 [&_blockquote]:border-gold [&_blockquote]:pl-4 [&_blockquote]:italic [&_a]:text-gold [&_a]:underline"
      />
    </div>
  );
};
